export const createSmoothScrollTo = (selector?: string) => (e: React.MouseEvent<HTMLElement>) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const hero = document.querySelector(selector || e.target.getAttribute('href'));
  e.preventDefault(); // Stop Page Reloading
  hero && hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export const smoothScrollTo = createSmoothScrollTo();
